import { useState } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { usePageAccess } from './usePageAccess'
import { PERMISSIONKEYS } from '../utils/Permissions.const'

const endpoint = '/api/user'

export function useUsers() {
  const { enabled } = usePageAccess(PERMISSIONKEYS.USERS)

  const [params, setParams] = useState({
    page: 1,
    pageSize: 20,
  })

  const queryFn = async () => {
    const { data } = await axios.get(endpoint, { params })
    return data
  }

  const { isLoading, data: response = {} } = useQuery({
    queryKey: [endpoint, params],
    queryFn,
    keepPreviousData: true,
    enabled,
  })

  return {
    isLoading,
    setParams,
    response,
  }
}
